var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProtocols(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 16.492 7.49541)",
    d: "m16.97755,4.18804l-4.02838,0l0,6.61475l4.02838,0c4.05161,-0.00106 4.10113,-6.61369 0,-6.61475z"
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-45 11.3778 10.0499)",
    y2: 10.04992,
    x2: 9.5703,
    y1: 10.04992,
    x1: 13.18523
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-45 13.8135 12.4469)",
    y2: 12.4469,
    x2: 12.00604,
    y1: 12.4469,
    x1: 15.62097
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_8",
    y2: 1.05548,
    x2: 22.94452,
    y1: 5.03279,
    x1: 18.96721
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 6.47668 17.599)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 5.67233 18.397)",
    d: "m6.15788,15.08968l-4.02839,0l0,6.61475l4.02839,0c4.05161,-0.00106 4.10112,-6.61369 0,-6.61475z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_10",
    y2: 11.95712,
    x2: 12.12485,
    y1: 15.93443,
    x1: 8.14754
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtocols);
export default __webpack_public_path__ + "static/media/icon-protocols.952f9418.svg";
export { ForwardRef as ReactComponent };